import {useState} from 'react'
import {makeStyles} from '@material-ui/core/styles'
import {DeleteIconButton, SelectButton, Text} from '../../1elements'
import SelectOwnerModal from './SelectOwnerModal'

const AssignOwner = ({showError, value, setValue}) => {
    const classes = useStyles()
    const [open, setOpen] = useState(false)

    const errorHandler = () => {
        if(showError&&!value){
            return 'Select owner of this group'
        }
    }

    const modalOpenHandler = () => {
        setOpen(true)
    }

    const deleteHandler = () => {
        setValue(null)
    }

    const userName = value&&value.username ? value.username : ''

    return (
        <div className={classes.root}>
            <Text type='fieldLabel'>
                Owner
                <span className={'requiredAsterisk'}>*</span>
            </Text>
            {
                !userName && (
                    <div className={classes.buttonDiv}>
                        <SelectButton onClick={modalOpenHandler} />
                    </div>
                )
            }
            {
                userName && (
                    <div className={classes.nameDeleteButtonDiv}>
                        <Text type='detailInfoHead'>{userName}</Text>
                        <DeleteIconButton onClick={deleteHandler} />
                    </div>
                )
            }

            <div className={classes.errorMessageDiv}>
                <Text type='textFieldError'>{errorHandler()}</Text>
            </div>
            <SelectOwnerModal open={open} setOpen={setOpen} owner={value} setOwner={setValue} />
        </div>
    )
}

export default AssignOwner

const useStyles = makeStyles({
    root: {},
    buttonDiv: {
        marginBottom: '10px',
        width: '100%',
        display: 'flex',
    },
    errorMessageDiv: {
        margin: '0 14px'
    },
    nameDeleteButtonDiv: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    }
})